const api = {
  baseURL: "https://api.guardservice.cl/",
  hojasDeCargoURL:"https://apilogistica.guardservice.cl/"
};
console.log(`Base URL is: ${api.baseURL}`);
console.log(`Hojas de Cargo URL is: ${api.hojasDeCargoURL}`);
export default api;
